import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import {AllowedPageSizes} from '../../../../../const/constants';
const WMSerialNumberNoHeaderInfoTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    
    const gridKey = "6CF685F1-AF69-45A4-93F4-6389449D4FC0";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <Scrolling mode="virtual" />
                <Column dataField="itemCode" caption='Item' dataType="string"></Column>
                <Column dataField="itemDescription1" caption='Item Description-1' dataType="string"></Column>
                <Column dataField="lotCode" caption='Lot' dataType="string"></Column>
                <Column dataField="lotDescription" caption='Lot Description-1' dataType="string"></Column>
                <Column dataField="serialNumber" caption='Serial#' dataType="string"></Column>
                <Column dataField="grossWeight" caption='Gross Weight' dataType="number" format="#,##0.00"></Column>
                <Column dataField="netWeight" caption='Net Weight' dataType="number" format="#,##0.00"></Column>
                <Column dataField="size1" caption='Size1' dataType="number" format="#,##0.00"></Column>


                <Column dataField="recordNumber" caption="Record #" dataType="string" visible={false}></Column>
                <Column dataField="itemDescription2" caption="'Item Description - 2" dataType="string" visible={false}></Column>
                <Column dataField="itemType" caption="Item Type" dataType="string" visible={false}></Column>
                <Column dataField="itemClassCode" caption="Item Class" dataType="string" visible={false}></Column>
                <Column dataField="itemSubClassCode" caption="Item Subclass" dataType="string" visible={false}></Column>
                <Column dataField="itemCode1" caption="Code-1 Item" dataType="string" visible={false}></Column>
                <Column dataField="itemCode2" caption="Code-2 Item" dataType="string" visible={false}></Column>
                <Column dataField="itemCode3" caption="Code-3 Item" dataType="string" visible={false}></Column>
                <Column dataField="itemCode4" caption="Code-4 Item" dataType="string" visible={false}></Column>
                <Column dataField="itemCode5" caption="Code-5 Item" dataType="string" visible={false}></Column>
                <Column dataField="itemRef1" caption="ItemRef1" dataType="string" visible={false}></Column>
                <Column dataField="itemRef2" caption="ItemRef2" dataType="string" visible={false}></Column>
                <Column dataField="itemRef3" caption="ItemRef3" dataType="string" visible={false}></Column>
                <Column dataField="itemRef4" caption="ItemRef4" dataType="string" visible={false}></Column>
                <Column dataField="itemRef5" caption="ItemRef5" dataType="string" visible={false}></Column>
                <Column dataField="itemDate1" caption="ItemDate1" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="itemDate2" caption="ItemDate2" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="itemDate3" caption="ItemDate3" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="itemDate4" caption="ItemDate4" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="itemDate5" caption="ItemDate5" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="itemQty1" caption="ItemQty1" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="itemQty2" caption="ItemQty2" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="itemQty3" caption="ItemQty3" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="itemQty4" caption="ItemQty4" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="itemQty5" caption="ItemQty5" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="lotDescription1" caption="Lot Description - 1" dataType="string" visible={false}></Column>
                <Column dataField="lotDescription2" caption="Lot Description - 2" dataType="string" visible={false}></Column>
                <Column dataField="lotClassCode" caption="Lot Class" dataType="string" visible={false}></Column>
                <Column dataField="lotSubClassCode" caption="Lot Subclass" dataType="string" visible={false}></Column>
                <Column dataField="lotCode1" caption="Code - 1 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotCode2" caption="Code - 2 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotCode3" caption="Code - 3 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotCode4" caption="Code - 4 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotCode5" caption="Code - 5 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotRef1" caption="Ref-1 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotRef2" caption="Ref-2 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotRef3" caption="Ref-3 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotRef4" caption="Ref-4 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotRef5" caption="Ref-5 Lot" dataType="string" visible={false}></Column>
                <Column dataField="lotDate1" caption="Date-1 Lot" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="lotDate2" caption="Date-2 Lot" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="lotDate3" caption="Date-3 Lot" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="lotDate4" caption="Date-4 Lot" dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="lotDate5" caption="Date-5 Lot"dataType="datetime" format="MM/dd/yyyy" visible={false}></Column>
                <Column dataField="lotQty1" caption="Qty-1 Lot" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="lotQty2" caption="Qty-2 Lot" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="lotQty3" caption="Qty-3 Lot" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="lotQty4" caption="Qty-4 Lot" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="lotQty5" caption="Qty-5 Lot" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="quantityOrder" caption="Ordered" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="quantityActual" caption="Actual" dataType="number" format="#,##0.00" visible={false}></Column>
                <Column dataField="calcAmount" caption="Amount" dataType="number" format="#,##0.00" visible={false}></Column>
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(WMSerialNumberNoHeaderInfoTab);